import type { ModuleId } from '@tahi/core';
import type { Usable } from '../../data/access';

export const MODULE_DESCRIPTIONS: Record<ModuleId, string> = {
  today: 'Your tiles from every module.',
  todo: 'Your tasks, including the ones other modules add.',
  calendar: 'Tasks, payments, and habits on one calendar.',
  spending: 'Log what you spend. Only the amount is needed.',
  budget: "Income, funds, and what's left each cutoff.",
  shopping: 'Things to buy, with prices you can compare over time.',
  payments: 'Bills, utilities, cards, and loans, with due dates.',
  habits: 'Habits and streaks, including gym days.',
  quit_smoking: 'Cut down to quit, with a daily limit that tapers.',
  weight: 'Log your weight and see the trend.',
  journal: 'Daily entries with a recap of your day.',
  export: 'Export your data for a spreadsheet or an AI assistant.',
};

/** Spec §6: when one module is off, say what the others won't do. */
export function linkNotes(usable: Usable): string[] {
  const notes: string[] = [];
  if (usable('payments') && !usable('budget'))
    notes.push(
      "Budget is off, so paying a bill won't take it out of a fund. Payments still go on your to-do list.",
    );
  if (usable('quit_smoking') && !usable('spending'))
    notes.push("Spending is off, so cigarette costs aren't logged as spending.");
  if (usable('budget') && !usable('spending'))
    notes.push('Budget has nothing to take out of your funds until Spending is on.');
  if (usable('shopping') && !usable('spending'))
    notes.push('Spending is off, so buying from your list records the trip but logs no expense.');
  if (usable('spending') && !usable('budget'))
    notes.push("Spending works on its own. Turn on Budget to see what's left.");
  return notes;
}
